<div class="h-100 pointer-events-none" [ngStyle]="customStyle">
  <form
    [formGroup]="selectCountryCurrencyForm"
    class="finxForm"
    [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
  >
    <div class="text-left">
      <div>
        <ng-template #customCurrencyOption let-currencyItem>
          <span class="d-inline-flex gap-2">
            @if (showCurrencyFlags) {
            <span class="d-contents" [innerHTML]="currencyItem.currencyFlag | safeHtml"></span>
            }
            <span>{{ currencyItem.title }}</span>
          </span>
        </ng-template>
        <ng-template #customCurrencySelectedOption>
          <span class="d-inline-flex gap-2">
            @if (showCurrencyFlags) {
            <span
              class="d-contents"
              [innerHTML]="selectedCurrencyOption?.currencyFlag ?? '' | safeHtml"
            ></span>
            }
            <span>{{ selectedCurrencyOption?.title }}</span>
          </span>
        </ng-template>
        <finxone-select-dropdown
          id="currency"
          formControlName="currency"
          [options]="currencyCodes"
          [customOptionTemplate]="customCurrencyOption"
          [customSelectedOptionTemplate]="customCurrencySelectedOption"
          [optionLabelKey]="'title'"
          [optionValueKey]="'value'"
          [appendToBody]="true"
          [searchEnabled]="true"
          [selectedOption]="selectCountryCurrencyForm.get('currency')?.value ?? ''"
          [label]="widgetConfig.attributes.widgetProperties.inputFieldSettings?.currencyLabel ?? ''"
          (selectionChange)="emitLatestValues()"
        >
        </finxone-select-dropdown>
      </div>
    </div>

    <div class="text-left">
      <div>
        <ng-template #customCountryOption let-countryItem>
          <span class="d-inline-flex gap-2">
            @if (showCurrencyFlags) {
            <span class="d-contents" [innerHTML]="countryItem.currencyFlag | safeHtml"></span>
            }
            <span>{{ countryItem.title }}</span>
          </span>
        </ng-template>
        <ng-template #customCountrySelectedOption>
          <span class="d-inline-flex gap-2">
            @if (showCurrencyFlags) {
            <span
              class="d-contents"
              [innerHTML]="selectedCountryOption?.currencyFlag ?? '' | safeHtml"
            ></span>
            }
            <span>{{ selectedCountryOption?.title }}</span>
          </span>
        </ng-template>
        <finxone-select-dropdown
          id="country"
          formControlName="country"
          [options]="countryList"
          [customOptionTemplate]="customCountryOption"
          [customSelectedOptionTemplate]="customCountrySelectedOption"
          [optionLabelKey]="'title'"
          [optionValueKey]="'key'"
          [appendToBody]="true"
          [searchEnabled]="true"
          [selectedOption]="selectCountryCurrencyForm.get('country')?.value ?? ''"
          [label]="widgetConfig?.attributes?.widgetProperties?.inputFieldSettings?.countryLabel ?? ''"
          (selectionChange)="emitLatestValues()"
        >
        </finxone-select-dropdown>
      </div>
    </div>

    @if (!isSubmitTypeAsynchronous) {
    <div class="mx-0 p-0 mt-4 submit-button pointer-events-none">
      <finx-button
        type="button"
        (click)="onSubmit()"
        [labeltext]="continueButtonContent"
        class="continue-button pointer-events-none d-flex"
        [class.h-100]="!isAllowedGlobalStyling"
        [buttonStyle]="!isAllowedGlobalStyling ? continueButtonStyle : {}"
        [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100 mandatory-cta-button'"
        [isAllowedGlobalStyling]="isAllowedGlobalStyling"
      ></finx-button>
    </div>
    }
  </form>
</div>
